var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavPortfolio = function SvgNavPortfolio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Nav_Portfolio_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.123 21.5a8.55 8.55 0 0 1-3.362-.686 8.379 8.379 0 0 1-2.737-1.853 8.444 8.444 0 0 1-1.869-2.8A8.625 8.625 0 0 1 2.5 12.86a8.8 8.8 0 0 1 .674-3.37 8.551 8.551 0 0 1 1.85-2.741 8.425 8.425 0 0 1 2.794-1.873 8.53 8.53 0 0 1 3.286-.657h.588l.038 8.033h7.978l.039.608a8.633 8.633 0 0 1-2.535 6.112 8.425 8.425 0 0 1-2.794 1.872 8.566 8.566 0 0 1-3.285.657h-.01Zm-.76-16.026a7.31 7.31 0 0 0-4.481 2.133 7.382 7.382 0 0 0-2.168 5.252c0 1.99.77 3.852 2.168 5.252a7.336 7.336 0 0 0 5.203 2.172 7.363 7.363 0 0 0 5.241-2.153 7.347 7.347 0 0 0 2.158-4.508l.02-.155h-7.988V5.464l-.154.02v-.01Zm2.687 5.493s-.038-.02-.038-.039V2.5l.665.02A8.599 8.599 0 0 1 18.957 5a8.59 8.59 0 0 1 2.485 5.281l.058.618-8.45.058v.01Z",
    fill: "#666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Nav_Portfolio_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.5 2.5)",
    d: "M0 0h19v19H0z"
  })))));
};
export default SvgNavPortfolio;